export default [
  {
    text: 'Дом целиком',
    value: 'wholly',
  },
  {
    text: 'Часть дома',
    value: 'partly',
  },
];
